import { isEmpty } from "lodash";

export async function post(url, body, token, uploadables) {
  let modBody;
  let requestVariables = {
    method: "POST",
    headers: {
      ...(token ? { Authorization: `JWT ${token}` } : {}),

      Accept: "application/json",
    },
  };

  if (!isEmpty(uploadables)) {
    if (!window.FormData) {
      throw new Error("Uploading files without `FormData` not supported.");
    }

    const formData = new FormData();
    formData.append("query", body.query);
    formData.append("variables", JSON.stringify(body.variables));

    Object.keys(uploadables).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(uploadables, key)) {
        formData.append(key, uploadables[key]);
      }
    });

    modBody = formData;

    const response = await fetch(url, {
      ...requestVariables,
      body: modBody,
    });

    if (!response.ok) {
      throw await response.json();
    }

    return response.json();
  } else {
    requestVariables.headers["Content-Type"] = "application/json";

    const response = await fetch(url, {
      ...requestVariables,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw await response.json();
    }

    return response.json();
  }
}

export async function get(url, { token, ...headers }) {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `JWT ${token}` } : {}),
      ...headers,
    },
  });

  if (!response.ok) {
    throw await response.json();
  }

  return response.json();
}
